import React from "react";
import { Link } from "react-router-dom";


export default function ServicesSection() {
  const services = [
    {
      title: "Digital Marketing Strategy",
      link: "/services/digital-marketing-strategy",
      desc: "Drive growth with data-driven digital marketing strategies that increase visibility, engagement, and qualified leads.",
      img: "/assets/images/Digital_Services.png",
    },
    {
      title: "Website & Software Development",
      link: "/services/website-and-software-development",
      desc: "Custom websites and scalable software solutions designed for performance, security, and seamless user experience.",
      img: "/assets/images/website_development.png",
    },
    {
      title: "Brand Building",
      link: "/services/brand-building",
      desc: "Create a strong, trusted brand identity that resonates with your audience and differentiates you in the healthcare market.",
      img: "/assets/images/brand_building.png",
    },
    {
      title: "Data Analytics",
      link: "/services/data-analytics",
      desc: "Transform raw data into actionable insights to improve decision-making, efficiency, and business outcomes.",
      img: "/assets/images/data_analytics.png",
    },
    {
      title: "Social Media Management",
      link: "/services/social-media-management",
      desc: "Build and manage a powerful social media presence to engage audiences, grow communities, and strengthen brand trust.",
      img: "/assets/images/social_media_management.png",
    },
    {
      title: "Healthtech Specific Solutions",
      link: "/services/healthtech-specific-solutions",
      desc: "Tailored technology solutions designed specifically for healthcare providers, startups, and healthtech enterprises.",
      img: "/assets/images/specific.png",
    },
    {
      title: "Support & Managed Services",
      link: "/services/support-and-managed-services",
      desc: "Reliable ongoing support and managed services to ensure system stability, performance, and continuous improvement.",
      img: "/assets/images/support.png",
    },
    {
      title: "Cloud Solutions",
      link: "/services/cloud-solutions",
      desc: "Secure, scalable cloud solutions that enhance flexibility, reduce costs, and support modern healthcare operations.",
      img: "/assets/images/cloud_solutions.png",
    },
  ];

  return (
    <div className="our-services page-service" role="main">
      

      <div className="container">
        {/* Services Grid */}
        <div className="row">
          {services.map((service, index) => (
            <ServiceItem
              key={index}
              {...service}
              delay={`${0.25 + index * 0.25}s`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/* Reusable Service Card */
function ServiceItem({ title, desc, img, link, delay }) {
  return (
    <div className="col-lg-4 col-md-6">
      <div
        className="service-item wow fadeInUp"
        data-wow-delay={delay}
      >
        <div className="service-content">
          <div className="service-content-title">
            <h2>{title}</h2>
            <Link to={link} aria-label={title}>
              <img src="./assets/images/arrow.svg" alt="" />
            </Link>
          </div>
          <p>{desc}</p>
        </div>

        <div className="service-image">
          <figure className="image-anime">
            <img src={img} alt={title} loading="lazy" />
          </figure>
        </div>
      </div>
    </div>
  );
}